<!-- schedule -->
<div class="schedule-section" [formGroup]="form" *ngIf="!isLoading">
    @if (hasSourcesEditPermission) {
        <button
            hc-icon-button
            class="cdp-simple-ico-btn"
            size="sm"
            (click)="clearSchedule()"
            hcTooltip="Clear schedule"
        >
            <span class="icon-trash clear-sched-ico"></span>
        </button>
    }
    <div class="cdp-row">
        <div class="col-custom schedule-col">
            <h4>
                <span><span class="icon-calendar-clock icon-left"></span>Schedule</span>
                @if (hasSourcesEditPermission) {
                    <hc-form-field [inline]="true" [tight]="true" class="sched-type-toggle">
                        <hc-radio-group
                            [inline]="true"
                            class="schedule-type"
                            formControlName="scheduleType"
                            (change)="onScheduleRadioClick()"
                        >
                            <hc-radio-button [title]="existingSchedHelp" [value]="scheduleTypes.Existing">{{
                                scheduleTypes.Existing
                            }}</hc-radio-button>
                            <hc-radio-button [title]="newSchedHelp" [value]="scheduleTypes.New">{{
                                scheduleTypes.New
                            }}</hc-radio-button>
                        </hc-radio-group>
                    </hc-form-field>
                }
            </h4>
            <div class="cdp-form-field" *ngIf="isExistingSchedule()">
                <label>
                    Schedule
                    @if (hasSourcesEditPermission) {
                        <span class="icon-info cdp-info-ico cdp-info-ico-right" [hcTooltip]="existingSchedHelp"></span>
                    }
                </label>
                <cdp-schedule-select
                    [tenantId]="tenantId"
                    [schedules]="schedules"
                    [hasSourcesEditPermission]="hasSourcesEditPermission"
                    [selectedScheduleName]="
                        hasSourcesEditPermission
                            ? form.value.scheduleDescription || ''
                            : form.value.scheduleDescription || 'No Schedule'
                    "
                    formControlName="scheduleId"
                    (scheduleChange)="onChangeSchedule($event)"
                ></cdp-schedule-select>
                <p class="error" *ngIf="scheduleControl.touched && scheduleControl.invalid">Schedule is required.</p>
                @if (tenantId && form.value.scheduleId && hasSourcesEditPermission) {
                    <a
                        class="sched-link"
                        href="/tenant/{{ tenantId }}/schedules/{{ form.value.scheduleId }}"
                        (click)="$event.stopPropagation()"
                    >
                        <span>Go to schedule</span>
                        <span class="icon-right icon-chev-right"></span>
                    </a>
                }
            </div>

            <div *ngIf="isNewSchedule()">
                <hc-form-field>
                    <hc-label
                        ><span cdpRequiredMarker></span>New Schedule Name

                        <button
                            *ngIf="form.controls['scheduleDescription'].value !== currentCronStr"
                            hc-button
                            buttonStyle="link"
                            size="sm"
                            (click)="setNameToMatchCron()"
                            class="match-cadence-btn cdp-fade-in"
                            title="Change name to match the schedule's cadence description"
                        >
                            Match name to cadence
                        </button>
                    </hc-label>
                    <span hcPrefix class="icon-calendar-clock"></span>
                    <input
                        hcInput
                        maxlength="255"
                        formControlName="scheduleDescription"
                        placeholder="Name this schedule"
                    />
                    <hc-error> Name is required for new schedules. </hc-error>
                </hc-form-field>

                <cdp-cron-editor
                    (cronChanged)="onCronChange($event)"
                    [formGroup]="form"
                    controlName="scheduleCron"
                ></cdp-cron-editor>
            </div>
        </div>
    </div>
</div>
